import React from 'react'
import { Container } from './components/Styled'

interface Props {
  title?: string
}

export const SectionTitle: React.FC<Props> = ({ title }) => {
  return (
    <Container>
      {title}
    </Container>
  )
}

export { Container }
